﻿import { OpaccNavigation } from "./vendor/script/classes/opacc.class.navigation.js";
import { opaccStorePlugin } from "./vendor/script/opacc.static.js";


export default class CustomNavigation extends OpaccNavigation {
    constructor() {
        super();
    }

    /**
	 * Event Registrierungen im DOM
	 */
	attachEventListener() {
		if (this.allStickyElems.length > 0) {
			this.stickyElementNavigation();
		}

		if (this.segmentNavigationWrapper) {
				opaccStorePlugin.init('persistentView');

				// check if view must be loaded from SessionStorage
				if (window.location.search.indexOf('take=') > 0 ) {
					opaccStorePlugin.get('persistentView', opaccStorePlugin.getCurrentURI());
				}

				this.firePseudoChangeEvent();

				this.segmentNavigationLoader();

		}

		if (this.offCanvasNaviElement || this.showAllCategoriesButtons.length > 0) {
			this.offCanvasNavigationListener();
		}

		if (this.navSelector.length > 0) {
			Array.from(this.navSelector).forEach( navigation => {
				navigation.addEventListener('click', e => {
					let elem = e.target;
					if (this.offCanvasWrapper && elem.closest(`.${this.offCanvasWrapper.className}`)) {
						if (elem.closest('.navigation-toggler')) {
							let liNaviElement = elem.closest(this.navLevelElement);
							if (liNaviElement.classList.contains('is-open')) {
								this.toggleIsOpenCssClass(liNaviElement);
							} else {
								this.closeSubNavigation(liNaviElement.parentElement.children, liNaviElement);
							}
						}
					} else {
						let liNaviElement = elem.closest(this.navLevelElement);

						if (liNaviElement) {
							if (liNaviElement.classList.contains('is-open')) {
								this.toggleIsOpenCssClass(liNaviElement);
							} else {
								let navLayout = elem.closest('[data-op-layout]');
								if (navLayout && navLayout.dataset.opLayout === 'arrow') {
									if (elem.closest('.navigation-toggler')) {
										this.closeSubNavigation(liNaviElement.parentElement.children, liNaviElement);
									} else {
										this.closeSubNavigation(liNaviElement.parentElement.children);
									}
								} else {
									this.closeSubNavigation(liNaviElement.parentElement.children, liNaviElement);
								}
							}
						}
					}
				}, false);
			});
		}
	}
}

